import React from "react";

import Link from "next/link";
import { CgArrowLeft, CgArrowRight } from "react-icons/cg";

interface NavButtonProps {
  link: string;
  label: string;
  internalLink?: boolean;
  onClick?(): void;
  back?: boolean;
  inverse?: boolean;
}

interface ATagProps {
  onClick?(): void;
}

export const NavButton: React.FC<React.PropsWithChildren<Readonly<NavButtonProps>>> = ({
  link,
  label,
  internalLink,
  back = false,
  inverse = false,
  onClick,
}) => {
  const aTagProps: ATagProps = {};
  if (onClick) {
    aTagProps.onClick = onClick;
  }
  if (internalLink) {
    return (
      <Link href={link} {...aTagProps}>
        <span
          className={`flex items-center text-sm ${back ? "justify-start" : "justify-end"} font-normal cursor-pointer ${
            inverse ? "text-white" : "text-od-blue"
          } hover:underline`}
        >
          {back && <CgArrowLeft className="w-4 h-4" />}
          <span>{label}</span>
          {!back && <CgArrowRight className="w-4 h-4" />}
        </span>
      </Link>
    );
  }

  return (
    <a href={link} {...aTagProps}>
      <span
        className={`flex items-center text-sm ${back ? "justify-start" : "justify-end"} font-normal cursor-pointer ${
          inverse ? "text-white" : "text-od-blue"
        } hover:underline`}
      >
        {back && <CgArrowLeft className="w-4 h-4" />}
        <span>{label}</span>
        {!back && <CgArrowRight className="w-4 h-4" />}
      </span>
    </a>
  );
};
